module.exports = __webpack_public_path__ + "img/arrow_up_3.fb0db6a7.svg";